<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="loading" class="text-center">
      <div class="text-center mb-3 justify-content-between">
        <b-spinner variant="primary"></b-spinner>
      </div>
    </div>
    <div v-else class="d-flex flex-column mx-2 mb-5 flex-wrap">
      <h2 style="display: flex;">Add a Poll</h2>
      <div class="rounded shadow p-3 border bg-white">
        <div class="d-flex flex-row my-3">
          <div class="w-50 me-3">
            <label class="">Poll Question</label>
            <input v-model="pollData.question" class="form-control" placeholder="Enter Question of this poll"
                   type="text"/>
          </div>
          <div class="d-flex flex-column me-3">
            <label class="footerLabels">Status</label>
            <select v-model="pollData.active_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
          </div>
          <div class="d-flex flex-column me-3">
            <label class="footerLabels">Immediate Result</label>
            <select v-model="pollData.show_percentage_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>
          <div class="d-flex flex-column">
            <label class="footerLabels">Show Result</label>
            <select v-model="pollData.enable_yn" class="py-2 border border-secondary rounded px-2 ">
              <option value="Y">Show</option>
              <option value="N">Don't Show</option>
            </select>
          </div>
        </div>
        <label class="footerLabels mb-3">Options</label>
        <div v-for="(option,index) in pollOptions" :key="option">
          <div class="d-flex flex-row mb-2">
            <input v-model="option.option_text" class="col-md-6 form-control me-3" placeholder="Enter Title of popup"
                   type="text"/>
            <select v-model="option.enable_yn" class="p-2 me-3 border border-secondary rounded">
              <option value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
            <button v-if="pollOptions.length > 1"
                    class="btn btn-danger btn-sm me-2" @click="deleteOption(index)"><span
                class="fa-solid fa-trash" style="width: 20px"></span>
            </button>
            <button v-if="index === pollOptions.length - 1"
                    class="btn btn-success btn-sm" @click="addNewOption"><span
                class="fa-solid fa-plus" style="width: 20px"></span>
            </button>
          </div>
        </div>
        <div class="d-flex flex-row mt-3">
          <div class="btn btn-primary" style="width: 100px;" type="button" @click="saveNewPoll">Save Poll
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config';
import {notify} from "@kyvg/vue3-notification";
import pollService from "@/services/poll.service";

export default {
  name: 'AddPoll',
  components: {},
  mounted() {
    this.imageBasePath = Config.apiFileBasePath;
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Polls',
          to: '/poll/all'
        }, {
          text: 'Add',
          href: '#'
        },

      ],
      loading: false,
      showModalText: false,
      showModalLogo: false,
      pollData: {
        question: "",
        active_yn: "N",
        enable_yn: "N",
        show_percentage_yn: "N",
      },
      pollOptions: [
        {
          option_text: "Option 1",
          enable_yn: "Y",
        },
        {
          option_text: "Option 2",
          enable_yn: "Y",
        },
      ],
      imageBasePath: null,
    }
  },
  methods: {
    deleteOption(index) {
      this.pollOptions.splice(index, 1);
    },
    validations() {
      if (this.pollData.question == null || this.pollData.question === "") {
        notify({
          type: "error",
          title: "Question can not be empty",
        });
        return false;
      }
      this.pollOptions.forEach(option => {
        if (option.option_text == null || option.option_text === "") {
          notify({
            type: "error",
            title: "Option text can not be empty",
          });
          return false;
        }
      })
      return true;
    },
    addNewOption() {
      this.pollOptions.push({
        option_text: "New Option ",
        enable_yn: "Y",
      })
    },
    async saveNewPoll() {
      try {
        if (!this.validations()) {
          return;
        }
        const requestBody = {
          question: this.pollData.question,
          active_yn: this.pollData.active_yn,
          enable_yn: this.pollData.enable_yn,
          show_percentage_yn: this.pollData.show_percentage_yn,
          pollOptionsList: [],
        };
        this.pollOptions.forEach(option => {
          requestBody.pollOptionsList.push(
              {
                option_text: option.option_text,
                enable_yn: option.enable_yn,
              }
          )
        });
        this.loading = true;
        const response = await pollService.savePollData(requestBody);
        this.loading = false;
        if (response.data) {
          if (response.data.status === true) {
            notify({
              type: "success",
              title: "Save Poll",
              text: response.data.message,
            });
          } else {
            notify({
              type: "error",
              title: "Error",
              text: response.data.message,
            });
          }
        } else {
          notify({
            type: "error",
            title: "Error",
            text: "Save poll data failed",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: "error",
          title: "Error",
          text: "Save poll data failed",
        });
      }
    }
  }
}
</script>

<style scoped>
.form-control {
  height: 35px;
  margin: 0px;
}
</style>